<ng-container *transloco="let t">
  <section
    class="highlights-banner"
    [class.mobile]="(biggerThan$ | async)?.xs"
    [class.widescreen]="(biggerThan$ | async)?.mobileL">
    @if ((biggerThan$ | async)?.mobileL && showTitle) {
      <h1 class="margin-0-auto">{{ t('label_better_popsy') }}</h1>
      <span class="fixed-space-24" aria-hidden="true"></span>
    }
    <ul class="list">
      <li class="item">
        <popsy-icon-warranty-dark
          class="icon"
          [class.fill-gray-light]="darkMode"></popsy-icon-warranty-dark>
        <span class="fixed-space-4" aria-hidden="true"></span>
        <span [class.text-gray-light]="darkMode" class="small">
          {{ t('title_featured_warranty_variable', { var1: months }) }}</span
        >
      </li>

      <li class="item">
        <popsy-icon-return-dark
          class="icon"
          [class.fill-gray-light]="darkMode"></popsy-icon-return-dark>
        <span class="fixed-space-4" aria-hidden="true"></span>
        <span [class.text-gray-light]="darkMode" class="small">
          {{ t('about_return_title') }}
        </span>
      </li>

      <li class="item">
        <popsy-icon-installments-dark
          class="icon"
          [class.fill-gray-light]="darkMode"></popsy-icon-installments-dark>
        <span class="fixed-space-4" aria-hidden="true"></span>
        <span [class.text-gray-light]="darkMode" class="small">
          {{ t('action_pay_installments') }}
        </span>
      </li>
    </ul>
  </section>
  <span class="fixed-space-16" aria-hidden="true"></span>
</ng-container>
